import React, { useEffect, useState } from 'react'
import Modal from 'react-responsive-modal';
import IconFloppyDisk from '../../../icons/floppy-disk';
import Select from "react-select";
import { SingleDatePicker } from 'react-dates';
import swal from 'sweetalert2';
import { apiDriverApp } from '../../../../libs/apiDriverApp';
import LoadMask from '../../Utils/LoadMask';
import moment from 'moment';
import 'react-dates/lib/css/_datepicker.css';
import DriverResetPasswordForm from './DriverResetPassword';
import { MapToFleetIOButton } from './mapToFleetIOBtn';
import ManagedInOdooNotice from './ManagedInOdooNotice';

const PasswordInput = ({ value, onChange, placeholder }) => {
    const [visible, setVisible] = useState(false);
    return (
        <div style={{ position: 'relative', display: 'block' }}>
            <input
                type={visible ? 'text' : 'password'}
                className='form-control'
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                style={{ paddingRight: '2.5rem' }}
            />
            <button
                type="button"
                onClick={() => setVisible((v) => !v)}
                aria-label={visible ? 'Hide password' : 'Show password'}
                tabIndex={-1}
                style={{
                    position: 'absolute',
                    right: 0,
                    top: 0,
                    bottom: 0,
                    width: '2.5rem',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    background: 'transparent',
                    border: 'none',
                    padding: 0,
                    color: '#666',
                    cursor: 'pointer',
                    zIndex: 2,
                }}
            >
                <i className={visible ? 'fa fa-eye-slash' : 'fa fa-eye'} />
            </button>
        </div>
    );
};

const generatePassword = (length = 12) => {
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnpqrstuvwxyz23456789';
    const crypto = typeof window !== 'undefined' && window.crypto;
    const bytes = new Uint32Array(length);
    if (crypto && crypto.getRandomValues) {
        crypto.getRandomValues(bytes);
    } else {
        for (let i = 0; i < length; i++) bytes[i] = Math.floor(Math.random() * 0xffffffff);
    }
    let out = '';
    for (let i = 0; i < length; i++) out += chars[bytes[i] % chars.length];
    return out;
};

export const ModalDriverForm = ({
    showModal,
    handleCloseModal,
    initialValues,
    title,
    jobs,
    getDrivers,
    setSelectedItem,
    getSchedules,
    externalLoading = false
  }) => {

    const [submitFormLoading, setSubmitFormLoading] = useState(false);
    const [resetPassLoading, setResetPassLoading] = useState(false);
    const [showModalResetPass, setShowModalResetPass] = useState(false);
    const [setPassLoading, setSetPassLoading] = useState(false);
    const [showModalSetPass, setShowModalSetPass] = useState(false);
    const [setPassValues, setSetPassValues] = useState({ password: '', password2: '' });
    const [termDateFocused, setTermDateFocused] = useState(false);

    const [formValues, setFormValues] = useState({
        firstName: '',
        lastName: '',
        phone: '',
        email: '',
        job: '',
        username: '',
        auto_generate: true,
        password: '',
        password2: '',
        fleetio_id: null,
        fleetio_last_sync_date: null,
        is_active: true
    });

    const handleChange = (name, value) => {
        setFormValues((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const driverTypes = [
        { value: 'white', label: 'White Belt' },
        { value: 'green', label: 'Green Belt' },
        { value: 'black', label: 'Black Belt' },
    ]

    useEffect(() => {
        if (initialValues) {
            setFormValues({
                firstName: initialValues.user.first_name || '',
                lastName: initialValues.user.last_name || '',
                phone: initialValues.mobile_phone || '',
                email: initialValues.user.email || '',
                job: initialValues.job ? initialValues.job.name : '',
                username: initialValues.user.username || '',
                auto_generate: true,
                password: '',
                password2: '',
                fleetio_id: initialValues.fleetio_id,
                fleetio_last_sync_date: initialValues.fleetio_last_sync_date,
                is_active: !!initialValues.user.is_active,
                is_driver_manager: !!initialValues.is_driver_manager,
                is_station_lead: !!initialValues.is_station_lead,
                is_take_home: !!initialValues.is_take_home,
                termination_date: initialValues.termination_date ? moment(initialValues.termination_date) : null,
                driver_type: initialValues.driver_type || null
            });
        } else {
            setFormValues({
                firstName: '',
                lastName: '',
                phone: '',
                email: '',
                job: '',
                username: '',
                auto_generate: true,
                password: '',
                password2: '',
                is_active: true,
                fleetio_id: null,
                fleetio_last_sync_date: null,
                is_driver_manager: false,
                is_station_lead: false,
                is_take_home: false,
                termination_date: null,
                driver_type: null
            });
        }
    }, [initialValues]);

    const handleCloseModalResetPass = () => {
        if (!resetPassLoading)
            setShowModalResetPass(false);
    }

    const handleResetPassword = async () => {
        const { value: result } = await swal({
            title: 'Reset Password?',
            text: 'This will require the driver to set a new password on their next login. They can use their PIN to log in.',
            type: 'warning',
            showCancelButton: true,
            reverseButtons: true,
            cancelButtonText: "Cancel",
            confirmButtonText: "Reset Password",
        });
        if (result)
            setShowModalResetPass(true);
    };
    
    const confirmResetPassword = async (values) => {
        try {
            setResetPassLoading(true);
            await apiDriverApp.post('api-auth/admin/reset-password-requirement/', {
                username: initialValues.user.username,
                password: values.pin,
            });
            swal('Success', 'Driver will be prompted to set a new password on next login', 'success');
            setShowModalResetPass(false);
        } catch (error) {
            console.error('Reset password error:', error);
            const msgError = error && error.response && error.response.data && error.response.data.error ? error.response.data.error : JSON.stringify(error);
            swal('Error', `Failed to reset password requirement: ${msgError}`, 'error');
        } finally {
            setResetPassLoading(false);
        }
    }

    const handleCloseModalSetPass = () => {
        if (!setPassLoading) {
            setShowModalSetPass(false);
            setSetPassValues({ password: '', password2: '' });
        }
    }

    const handleSetPassword = () => {
        setSetPassValues({ password: '', password2: '' });
        setShowModalSetPass(true);
    }

    const confirmSetPassword = async () => {
        if (!setPassValues.password) {
            swal('Missing Password', 'Please enter a new password.', 'error');
            return;
        }
        if (setPassValues.password !== setPassValues.password2) {
            swal('Passwords do not match', 'Please verify the password.', 'error');
            return;
        }
        try {
            setSetPassLoading(true);
            await apiDriverApp.post(`api/hr/users/${initialValues.user.id}/set-password/`, {
                password: setPassValues.password,
            });
            swal('Success', 'Password updated successfully', 'success');
            setShowModalSetPass(false);
            setSetPassValues({ password: '', password2: '' });
        } catch (error) {
            console.error('Set password error:', error);
            const msgError = error && error.response && error.response.data && error.response.data.error ? error.response.data.error : JSON.stringify(error);
            swal('Error', `Failed to set password: ${msgError}`, 'error');
        } finally {
            setSetPassLoading(false);
        }
    }

    const handleSubmit = async () => {
        // Validaciones iniciales
        if (!formValues || formValues.firstName === '' ||
            formValues.lastName === '' || formValues.phone === '' ||
            formValues.email === '' || formValues.job === '' ||
            formValues.username === '') {
            swal("Missing Fields", 'Please verify that required fields are filled', "error");
            return;
        }

        if (!initialValues && !formValues.auto_generate) {
            if (!formValues.password) {
                swal("Missing Password", "Please enter a password or enable Auto-generate.", "error");
                return;
            }
            if (formValues.password !== formValues.password2) {
                swal("Passwords do not match", "Please verify the password.", "error");
                return;
            }
        }

        const formattedTerminationDate = formValues.termination_date ?
            formValues.termination_date.format('YYYY-MM-DD') : null;

        try {
            setSubmitFormLoading(true);
            if (initialValues) {
                const initialJob = initialValues.job ? initialValues.job.name : '';

                const changes = {};
                changes.username = initialValues.user.username;
                if (formValues.email !== initialValues.user.email) changes.email = formValues.email;
                if (formValues.firstName !== initialValues.user.first_name) changes.first_name = formValues.firstName;
                if (formValues.lastName !== initialValues.user.last_name) changes.last_name = formValues.lastName;
                if (formValues.job !== initialJob) changes.job = formValues.job;
                if (formValues.phone !== initialValues.mobile_phone) changes.mobile_phone = formValues.phone;
                if (formValues.is_active !== !!initialValues.user.is_active) {
                    changes.is_active = formValues.is_active;
                    changes.active = formValues.is_active;
                };
                if (formValues.is_driver_manager !== !!initialValues.is_driver_manager) {
                    changes.is_driver_manager = formValues.is_driver_manager;
                }
                if (formValues.is_station_lead !== !!initialValues.is_station_lead) {
                    changes.is_station_lead = formValues.is_station_lead;
                }
                if (formValues.is_take_home !== !!initialValues.is_take_home) {
                    changes.is_take_home = formValues.is_take_home;
                }
                if (formattedTerminationDate !== initialValues.termination_date) {
                    changes.termination_date = formattedTerminationDate;
                }
                if (formValues.driver_type !== initialValues.driver_type) {
                    changes.driver_type = formValues.driver_type;
                }
                // Editar
                if (Object.keys(changes).length > 0) {
                    const { data } = await apiDriverApp.post('api/hr/employees/update_or_create/', changes);
                  }

            } else {
                // Crear
                const passwordToSend = formValues.auto_generate
                    ? generatePassword()
                    : formValues.password;
                const body = {
                    username: formValues.username,
                    email: formValues.email,
                    first_name: formValues.firstName,
                    last_name: formValues.lastName,
                    job: formValues.job,
                    mobile_phone: formValues.phone,
                    password: passwordToSend,
                    is_active: formValues.is_active,
                    active: formValues.is_active,
                    is_driver_manager: formValues.is_driver_manager,
                    is_station_lead: formValues.is_station_lead,
                    is_take_home: formValues.is_take_home,
                    termination_date: formattedTerminationDate,
                    driver_type: formValues.driver_type
                }
                const { data } = await apiDriverApp.post('api/hr/employees/update_or_create/', body );

                if (formValues.auto_generate) {
                    await swal({
                        title: 'Driver created',
                        html: `<div>The auto-generated password is:</div>`
                            + `<div style="font-family: monospace; font-size: 1.25rem; font-weight: 600; margin-top: 0.75rem; padding: 0.5rem 0.75rem; background: #f4f4f4; border-radius: 4px; user-select: all;">${passwordToSend}</div>`
                            + `<div style="margin-top: 0.75rem; font-size: 0.9rem;">Copy it now — it won't be shown again.</div>`,
                        type: 'success',
                        confirmButtonText: 'OK',
                    });
                    getDrivers();
                    getSchedules();
                    handleCloseModal();
                    return;
                }
            }

            // Si la solicitud tiene éxito
            swal('Success', `Driver ${initialValues ? 'edited' : 'created'} with success`, 'success')
            getDrivers();
            getSchedules();
            handleCloseModal();
        } catch (error) {
            console.error("Error:", error);

            if (error.response) {
                swal("Error", error.response.data.error || "An error occurred", "error");
            } else if (error.request) {
                swal("Network Error", "No response from server. Please try again later.", "error");
            } else {
                swal("Error", "An unexpected error occurred", "error");
            }
        } finally {
            setSubmitFormLoading(false);
        }
    };

    return (
        <React.Fragment>
            <Modal
                open={showModal}
                onClose={handleCloseModal}
                showCloseIcon={false}
                blockScroll={false}
                styles={{ modal: { minWidth: '35%', borderRadius: '8px', marginTop: 50, padding: 0 } }}
                closeOnOverlayClick={!submitFormLoading}
            >
                <LoadMask loading={submitFormLoading || externalLoading} light>
                <div className="d-flex row m-0 justify-content-between align-items-center px-4 pt-3">
                    <div className='col-6 px-0 mb-2'>
                        <h4 style={{ fontWeight: 'bold' }}>{title}</h4>
                    </div>

                    <div className="d-flex justify-content-between align-items-center">

                        <button onClick={handleCloseModal} className="btn d-flex align-items-center rounded shadow-sm px-3 py-2 me-3" style={{ backgroundColor: '#D50032', color: 'white' }}>
                            <div style={{ display: 'flex', alignItems: 'center', height: '0.8rem' }}>
                                X
                            </div>
                            <span className="ml-1">Close</span>
                        </button>

                        {initialValues && (
                            <button
                                onClick={handleResetPassword}
                                className="btn border border-warning rounded shadow-sm px-3 py-2 d-flex align-items-center ml-3"
                                style={{ backgroundColor: '#FFC107', color: '#000' }}
                            >
                                <span style={{ fontWeight: 'bold' }}>Reset Password</span>
                            </button>
                        )}

                        {initialValues && (
                            <button
                                onClick={handleSetPassword}
                                className="btn border border-dark rounded shadow-sm px-3 py-2 d-flex align-items-center ml-3"
                                style={{ backgroundColor: '#fff', color: '#000' }}
                            >
                                <span style={{ fontWeight: 'bold' }}>Set Password</span>
                            </button>
                        )}

                        <button className="btn border border-dark rounded shadow-sm px-3 py-2 d-flex align-items-center ml-3" onClick={handleSubmit}>
                            <div style={{ display: 'flex', alignItems: 'center', height: '0.8rem' }}>
                                <IconFloppyDisk className='h-100' />
                            </div>
                            <span className="ml-1" style={{ fontWeight: 'bold' }}>Save</span>
                        </button>
                    </div>
                </div>

                <hr />

                <div className="container px-5">
                    <div className="driver-form__active-field">
                        <input
                            type="checkbox"
                            id="is_active"
                            checked={formValues.is_active}
                            onChange={(e) => {
                                const value = e.target.checked;
                                handleChange('is_active', value);
                                if (!value && !formValues.termination_date)
                                    handleChange('termination_date', moment());
                            }}
                        />
                        <label htmlFor="is_active">Active</label>
                    </div>

                    <div className="row mb-3">
                        <div className="col-md-6">
                            <h6>First Name</h6>
                            <input
                                placeholder='Mike'
                                className='form-control'
                                value={formValues.firstName}
                                onChange={(e) => handleChange('firstName', e.target.value)}
                            />
                        </div>
                        <div className="col-md-6 ">
                            <h6>Last Name</h6>
                            <input
                                placeholder='Perry'
                                className='form-control'
                                value={formValues.lastName}
                                onChange={(e) => handleChange('lastName', e.target.value)}
                            />
                        </div>
                    </div>

                    <div className="row mb-3">
                        <div className="col-md-6">
                            <h6>Mobile Phone</h6>
                            <input
                                placeholder='703-456-7890'
                                className='form-control'
                                value={formValues.phone}
                                onChange={(e) => handleChange('phone', e.target.value)}
                            />
                        </div>
                        <div className="col-md-6 ">
                            <h6>Email</h6>
                            <input
                                placeholder='no@email.com'
                                className='form-control'
                                value={formValues.email}
                                onChange={(e) => handleChange('email', e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <div>
                                <h6>Assigned Job</h6>
                                <Select
                                    options={jobs}
                                    value={formValues.job}
                                    onChange={(option) => handleChange('job', option.value)}
                                    placeholder="Shuttle Driver - WAS"
                                    clearable={false}
                                />
                            </div>

                            <div className="mt-3">
                                <h6>Username / Driver ID</h6>
                                <input
                                    placeholder='9000'
                                    className='form-control'
                                    value={formValues.username}
                                    onChange={(e) => handleChange('username', e.target.value)}
                                    disabled={initialValues}
                                />
                            </div>

                            {initialValues && (
                                <div className='mt-3'>
                                    <h6>Fleetio ID</h6>
                                    <MapToFleetIOButton
                                        username={initialValues.user.username}
                                        fleetio_id={initialValues.fleetio_id}
                                        last_sync={initialValues.fleetio_last_sync_date}
                                        onClick={(newData)=>{
                                            getDrivers();
                                            setSelectedItem({
                                                ...initialValues,
                                                ...newData
                                            })
                                        }}
                                    />
                                </div>
                            )}

                            <div className="mt-3">
                                <h6>Classification</h6>
                                <Select
                                    options={driverTypes}
                                    value={
                                    driverTypes.find((option) => option.value === formValues.driver_type) ||
                                    null
                                    }
                                    onChange={(option) => handleChange('driver_type', option ? option.value : null)}
                                    placeholder="Driver Type"
                                    searchable={false}
                                />
                            </div>

                            <div className="mt-3">
                                <h6 >Termination Date</h6>
                                <div className='form-control p-1'>
                                    <SingleDatePicker
                                        id="date_input"
                                        date={formValues.termination_date}
                                        onDateChange={(newDate) => handleChange('termination_date', newDate)}
                                        focused={termDateFocused}
                                        onFocusChange={({ focused }) => setTermDateFocused(focused)}
                                        numberOfMonths={1}
                                        isOutsideRange={() => false}
                                        placeholder='2025-01-01'
                                        openDirection="up"
                                    />
                                </div>
                                {/* show message if date is before than current */}
                                {formValues.termination_date && (
                                    formValues.termination_date.isBefore(moment(), 'day') &&
                                    formValues.is_active
                                ) && (
                                    <div className="text-danger mt-2"
                                        style={{ maxWidth: '220px', fontSize: '15px' }}>
                                        This date will inactivate the driver.
                                    </div>
                                )}
                            </div>

                        </div>
                        <div className="col-md-6 ">
                            <h6>Schedule</h6>
                            <ManagedInOdooNotice what="Schedule assignment" />

                            {!initialValues && (
                                <React.Fragment>
                                    <div className="mt-3 driver-form__checkbox-field">
                                        <input
                                            type="checkbox"
                                            id="auto_generate"
                                            checked={formValues.auto_generate}
                                            onChange={(e) => handleChange('auto_generate', e.target.checked)}
                                        />
                                        <label htmlFor="auto_generate">Auto-generate password</label>
                                    </div>

                                    {!formValues.auto_generate && (
                                        <React.Fragment>
                                            <div className="mt-3">
                                                <h6>Password</h6>
                                                <PasswordInput
                                                    placeholder='Enter custom password'
                                                    value={formValues.password}
                                                    onChange={(e) => handleChange('password', e.target.value)}
                                                />
                                            </div>

                                            <div className="mt-3">
                                                <h6>Confirm Password</h6>
                                                <PasswordInput
                                                    placeholder='Re-enter password'
                                                    value={formValues.password2}
                                                    onChange={(e) => handleChange('password2', e.target.value)}
                                                />
                                            </div>
                                        </React.Fragment>
                                    )}
                                </React.Fragment>
                            )}

                            <div>
                                <div className="driver-form__checkbox-field">
                                    <input
                                        type="checkbox"
                                        id="is_driver_manager"
                                        checked={formValues.is_driver_manager}
                                        onChange={(e) => handleChange('is_driver_manager', e.target.checked)}
                                    />
                                    <label htmlFor="is_driver_manager">Driver Manager</label>
                                </div>

                                <div className="driver-form__checkbox-field">
                                    <input
                                        type="checkbox"
                                        id="is_station_lead"
                                        checked={formValues.is_station_lead}
                                        onChange={(e) => handleChange('is_station_lead', e.target.checked)}
                                    />
                                    <label htmlFor="is_station_lead">Station Lead</label>
                                </div>

                                <div className="driver-form__checkbox-field">
                                    <input
                                        type="checkbox"
                                        id="is_take_home"
                                        checked={formValues.is_take_home}
                                        onChange={(e) => handleChange('is_take_home', e.target.checked)}
                                    />
                                    <label htmlFor="is_take_home">Vehicle Take Home</label>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row mb-3 ">

                    </div>
                </div>
                </LoadMask>
            </Modal>
            <Modal
                open={showModalResetPass}
                onClose={handleCloseModalResetPass}                            
                showCloseIcon={false}
                blockScroll={false}
                styles={{ modal: { borderRadius: '8px' } }}
                closeOnOverlayClick={!resetPassLoading}
            >
                <div className="w-100 d-flex justify-content-between align-items-center px-4 pt-3 mb-2">
                    <div className=''>
                        <h4 className="fw-bold">Reset Password</h4>
                    </div>

                    <div className="d-flex justify-content-between align-items-center">
                        <button
                            onClick={handleCloseModalResetPass}
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span style={{fontSize: "2.5rem"}} aria-hidden="true">
                                &times;
                            </span>
                        </button>
                    </div>
                </div>

                <hr />

                <LoadMask loading={resetPassLoading} light>
                    <DriverResetPasswordForm
                        onSubmit={confirmResetPassword}
                    />
                </LoadMask>
            </Modal>
            <Modal
                open={showModalSetPass}
                onClose={handleCloseModalSetPass}
                showCloseIcon={false}
                blockScroll={false}
                styles={{ modal: { borderRadius: '8px' } }}
                closeOnOverlayClick={!setPassLoading}
            >
                <div className="w-100 d-flex justify-content-between align-items-center px-4 pt-3 mb-2">
                    <div className=''>
                        <h4 className="fw-bold">Set Password</h4>
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                        <button
                            onClick={handleCloseModalSetPass}
                            type="button"
                            className="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span style={{fontSize: "2.5rem"}} aria-hidden="true">
                                &times;
                            </span>
                        </button>
                    </div>
                </div>
                <hr />
                <LoadMask loading={setPassLoading} light>
                    <div className="px-4 pb-4">
                        <div className="text-muted mb-3" style={{ fontSize: '0.9rem' }}>
                            Set a new password for <strong>{initialValues && initialValues.user.username}</strong>. The driver will use this password on next login (no forced reset).
                        </div>
                        <div className="mb-3">
                            <h6>New Password</h6>
                            <PasswordInput
                                placeholder='Enter new password'
                                value={setPassValues.password}
                                onChange={(e) => setSetPassValues((prev) => ({ ...prev, password: e.target.value }))}
                            />
                        </div>
                        <div className="mb-3">
                            <h6>Confirm Password</h6>
                            <PasswordInput
                                placeholder='Re-enter password'
                                value={setPassValues.password2}
                                onChange={(e) => setSetPassValues((prev) => ({ ...prev, password2: e.target.value }))}
                            />
                        </div>
                        <div className="d-flex justify-content-end">
                            <button
                                type="button"
                                className="btn btn-outline-secondary px-4 py-2 mr-2"
                                onClick={handleCloseModalSetPass}
                            >
                                Cancel
                            </button>
                            <button
                                type="button"
                                className="btn btn-primary px-4 py-2 d-flex align-items-center"
                                onClick={confirmSetPassword}
                            >
                                <div style={{ height: '0.9rem', display: 'inline-flex', alignItems: 'center', marginRight: '0.5rem' }}>
                                    <IconFloppyDisk className='h-100' />
                                </div>
                                Save
                            </button>
                        </div>
                    </div>
                </LoadMask>
            </Modal>
        </React.Fragment>

    )
}
